export default __webpack_public_path__ + "static/node-fed00edbc838719d7abfb9e771adc93b.png";